/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, October 18th 2021, 7:19:38 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { AutoSaveFormProvider, AutoSaveFormProviderProps } from "ui-widgets/forms/providers";
import { OSAPIForm, OSAPIFormProps } from "./OSAPIForm";

type AutoSaveAPIFormProps<TAPIFormData, TAPIResponse> = Pick<AutoSaveFormProviderProps<TAPIFormData>, "doDebounce"> &
  OSAPIFormProps<TAPIFormData, TAPIResponse>;

export const AutoSaveAPIForm = <TAPIFormData, TAPIResponse = TAPIFormData>(
  props: AutoSaveAPIFormProps<TAPIFormData, TAPIResponse>
) => {
  const { apiObjectId } = props.useAPIFormReturn;
  const dataIsNew = !apiObjectId;

  return (
    <OSAPIForm<TAPIFormData, TAPIResponse> {...props}>
      <AutoSaveFormProvider
        isNewData={dataIsNew}
        useFormReturn={props.useAPIFormReturn.useFormReturn}
        submitFunction={props.useAPIFormReturn.submitAPIForm}
        doDebounce={props.doDebounce}
      >
        {props.children}
      </AutoSaveFormProvider>
    </OSAPIForm>
  );
};
